import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { useContext } from "react";
import { organizationProfilePath } from "@app/projects/network-assessment/provider-hub/providerHubProfilePaths";

export const useOrganizationLink = () => {
  const projectContext = useContext(CountyProjectContext);

  return (organizationNpi: string, contractEntityId: number): string => `${window.customUIBaseUrl}${organizationProfilePath(projectContext.project.projectId, projectContext.runConfiguration.projectRunConfigurationId, organizationNpi, contractEntityId)}`;
}
